export const EMPLOYEE_STATUS_LABEL: Record<string, string> = {
  ACTIVE: "Active",
  REGISTERED_UNVERIFIED: "Registered – phone unverified",
  PENDING_REVIEW: "Pending review",
  DEACTIVATED: "Deactivated",
};

export const INVITATION_STATUS_LABEL: Record<string, string> = {
  PENDING: "Pending",
  NEEDS_REVIEW: "Needs review",
  MATCHED: "Matched",
  EXPIRED: "Expired",
  REVOKED: "Revoked",
  REJECTED: "Rejected",
};

export const fmtDate = (d: string | null | undefined) => (d ? new Date(d).toLocaleString() : "—");
export const fmtDay = (d: string | null | undefined) => (d ? new Date(d).toLocaleDateString() : "—");
